import { Button, Card, Checkbox, Typography } from 'antd';
import { FC, useEffect, useState } from 'react';
import FilePreview from '../../../../../shared/file-preview/file-preview';

interface FilePickerCoverLetterFileSelectionProps {
  files: Array<string>
  // files: Array<{
  //   type: string;
  //   label: string;
  //   fileName?: string;
  // }>;
  selectedFilesMap: SelectedFilesMap;
  onFileSelect: (fileType: string) => void;
  currentFileSelection: string;
  onCancel: () => void;
  onGenerateDocument: () => void;
  title: string;
  imageFile: {
    type: string;
    label: string;
    fileName?: string;
  };
  onSelectedFilesChange: (selectedFiles: string[]) => void;
  isLoading: boolean;
  isProcessingUploadingFile?: boolean;
}

export interface SelectedFileInfo {
  name: string;
  url: string;
  type: string;
  caseType: string;
  caseId: string;
}

export interface SelectedFilesMap {
  [key: string]: SelectedFileInfo | null;
}

export const FilePickerCoverLetterFileSelection: FC<FilePickerCoverLetterFileSelectionProps> = (props) => {
  const [selectedFiles, setSelectedFiles] = useState<string[]>([props.files[0]]);

  useEffect(() => {
    props.onSelectedFilesChange(selectedFiles);
  }, [selectedFiles]);


  const handleCheck = (file: string, checked: boolean) => {
    if (checked) {
      setSelectedFiles((prev) => [...prev, file]); // Add to selected files
    } else {
      setSelectedFiles((prev) => prev.filter((item) => item !== file)); // Remove from selected files
    }
  };

  return (
    <Card title={props.title} style={{width:"320px"}}>
      <Typography.Text style={{ fontSize: '14px' }}>Included Documents:</Typography.Text>
      {props.files.map((file, index) => (
        <div
          key={file}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '30px',
            marginTop: 15,
            marginLeft: 20
          }}
        >
          <Checkbox
            value={file}
            onChange={(e) => handleCheck(file, e.target.checked)}
            checked={selectedFiles.includes(file)}
            disabled={index === 0}
          >
            {file}
          </Checkbox>
        </div>
      ))}
            <Typography.Text style={{ fontSize: '14px' }}>Photo:</Typography.Text>
      <div
        key={props.imageFile.type}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '30px',
          marginTop: 15,
          marginLeft: 10
        }}
      >
        <FilePreview
          fileUrl={props.selectedFilesMap[props.imageFile.type]?.url ?? ''}
          fileName={props.imageFile.fileName ?? 'photo.jpg'}
          fileType={props.selectedFilesMap[props.imageFile.type]?.type ?? ''}
        />
        <Button type={props.currentFileSelection === props.imageFile.type ? 'primary' : 'default'} onClick={() => props.onFileSelect(props.imageFile.type)}>
          {props.imageFile.label}
        </Button>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '80px',
        }}
      >
        <Button onClick={props.onCancel} disabled={props.isLoading} style={{ marginRight: '10px' }}>
          Cancel
        </Button>
        <Button type="primary" disabled={props.isProcessingUploadingFile} onClick={props.onGenerateDocument} loading={props.isLoading}>
          Generate Document
        </Button>
      </div>
    </Card>
  );
};
